import { takeEvery, select, put } from 'redux-saga/effects'
import { difference } from 'lodash'

import {
  updateOrganizationProtrackLevelTeams,
  updateOrganizationProtrackLevelTeamsSuccessForMicroactions,
} from '../actions'
import { getPendingObject, getOrganizationTeamsById, getEditingOrganizationFormValues } from '../selectors'
import { organizationId as getOrganizationId } from 'store/entities/router/selectors'
import { getPublishedProtracksList } from 'store/entities/protracks/selectors'

export function* handleUpdateOrganizationProtrackLevelTeamsSuccess() {
  const pendingObject = yield select(getPendingObject)
  const organizationId = yield select(getOrganizationId)
  const organizationTeamsList = yield select(getOrganizationTeamsById(organizationId))
  const newTeams = difference(pendingObject.teams.toJS(), organizationTeamsList.toJS())
  const publishedList = yield select(getPublishedProtracksList)
  const {
    teams,
    proTrackLevelId,
    isOrganizationProTrackLevelActive,
    customProTrackLevelName,
    hasActiveUsersProTrackLevelName,
    selectedProTrackLevelName,
    proTrackId,
  } = pendingObject
  const proTrack = publishedList.find(proTrack => proTrack.get('id') === proTrackId)
  const level = proTrack.get('levels').find(level => level.get('id') === proTrackLevelId)
  const payloadNew = {
    proTrackLevelId,
    teams,
    newTeams,
    organizationId,
    organizationTeams: organizationTeamsList,
    isOrganizationProTrackLevelActive,
    customProTrackLevelName,
    hasActiveUsersProTrackLevelName,
    selectedProTrackLevelName,
    level,
  }
  yield put(updateOrganizationProtrackLevelTeamsSuccessForMicroactions(payloadNew as any))
}

export default function* takeEveryUpdateOrganizationProtrackLevelTeams() {
  yield takeEvery(
    updateOrganizationProtrackLevelTeams.success.toString(),
    handleUpdateOrganizationProtrackLevelTeamsSuccess
  )
}
